import React from "react";
import Data from "../content.json";

import { FaHandPointRight } from "react-icons/fa";
import { Helmet } from "react-helmet";

function TeachingMembers() {
  return (
    <>
      <Helmet>
        <title>Faculty Member | University of Education</title>
      </Helmet>
      <div className="MembersContainer">
        <div id="Heading">
          <h1>Faculty Members</h1>
        </div>

        <div className="Members">
          {Object.entries(Data.teachingMembers).map((teachingData) => {
            console.log(teachingData[1]);

            return (
              <div className="MemberCard" data-aos="fade-up">
                <div className="TopMemberCard">
                  <img src={teachingData[1].img} alt="memberImg1" />
                  <h2>{teachingData[1].name}</h2>
                  <h4>{teachingData[1].role}</h4>
                </div>
                <div className="MiddleMemberCard">
                  <table>
                    <tbody>
                      {teachingData[1].qualification && (
                        <tr>
                          <td style={{ verticalAlign: "top", paddingRight: "10px", width: "20px" }}>
                            <FaHandPointRight className="tickIcon" />
                          </td>
                          <td style={{ textAlign: "left" }}>
                            <p>{teachingData[1].qualification}</p>
                          </td>
                        </tr>
                      )}
                      {teachingData[1].email && (
                        <tr>
                          <td style={{ verticalAlign: "top", paddingRight: "10px", width: "20px" }}>
                            <FaHandPointRight className="tickIcon" />
                          </td>
                          <td style={{ textAlign: "left", wordBreak: "break-all" }}>
                            <p>{teachingData[1].email}</p>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default TeachingMembers;
